<div class="label-with-icon">
  <h2 class="form-headline">{{ headline() }}</h2>
  @if (tooltipText()) {
    <svg class="icon-20" [matTooltip]="tooltipText()"><use href="assets/images/ok-icons-sprite.svg#info-s"></use></svg>
  }
</div>
<div class="duo-input">
  <mat-form-field title="Ekskl. moms">
    <mat-label>Ekskl. moms</mat-label>
    <input
      matInput
      type="text"
      [formControl]="exclVatDisplayControl"
      [errorStateMatcher]="exclVatErrorStateMatcher"
      (focus)="onExclFocus()"
      (blur)="onExclBlur()" />
  </mat-form-field>
  <mat-form-field>
    <mat-label>Inkl. moms</mat-label>
    <input
      matInput
      type="text"
      [formControl]="inclVatDummyControl"
      [errorStateMatcher]="inclVatErrorStateMatcher"
      (focus)="onInclFocus()"
      (blur)="onInclBlur()" />
  </mat-form-field>
</div>
